import React from 'react';
import Info from '../assets/images/info2.svg'
import styles from './InfoLink.scss'

const InfoLink = (props) => (
  <a href={props.link} className="d-inline-block" target="_blank">
    <img className={styles.InfoLink} src={Info}/>
  </a>
);

export default  InfoLink;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/InfoLink.jsx